export const languagesSk = {
  languages: {
    // Primary/Common European languages (sort_order 1-20)
    'en': 'Angličtina',
    'sk': 'Slovenčina',
    'cs': 'Čeština',
    'de': 'Nemčina',
    'da': 'Dánčina',
    'es': 'Španielčina',
    'fr': 'Francúzština',
    'it': 'Taliančina',
    'pl': 'Poľština',
    'hu': 'Maďarčina',
    'ro': 'Rumunčina',
    'nl': 'Holandčina',
    'pt': 'Portugalčina',
    'ru': 'Ruština',
    'uk': 'Ukrajinčina',
    'el': 'Gréčtina',
    'bg': 'Bulharčina',
    'hr': 'Chorvátčina',
    'sl': 'Slovinčina',
    'sv': 'Švédčina',
    'lv': 'Lotyština',

    // Other European languages (sort_order 21-30)
    'lt': 'Litovčina',
    'et': 'Estónčina',
    'fi': 'Fínčina',
    'ga': 'Írčina',
    'mt': 'Maltčina',

    // Major Asian languages (sort_order 31-50)
    'zh': 'Mandarínska čínština',
    'hi': 'Hindčina',
    'bn': 'Bengálčina',
    'ja': 'Japončina',
    'ko': 'Kórejčina',
    'vi': 'Vietnamčina',
    'th': 'Thajčina',
    'tr': 'Turečtina',
    'id': 'Indonézština',
    'ms': 'Malajčina',
    'tl': 'Tagalčina',
    'my': 'Barmčina',
    'km': 'Khmérčina',
    'ne': 'Nepálčina',

    // Indian languages (sort_order 51-70)
    'te': 'Telugčina',
    'mr': 'Maráthčina',
    'ta': 'Tamilčina',
    'gu': 'Gudžarátčina',
    'kn': 'Kannadčina',
    'ml': 'Malajálamčina',
    'or': 'Uríjčina',
    'pa': 'Pandžábčina',
    'as': 'Ásámčina',
    'mai': 'Maithilčina',
    'mag': 'Magahčina',
    'hne': 'Čhattísgarhčina',
    'bho': 'Bhódžpurčina',
    'ur': 'Urdčina',
    'sd': 'Sindhčina',
    'skr': 'Saraíkčina',
    'si': 'Sinhalčina',

    // Chinese dialects/variants (sort_order 71-80)
    'wuu': 'Čínština Wu',
    'yue': 'Čínština Yue',
    'nan': 'Južná Mincština',
    'hak': 'Hakkčina',
    'cjy': 'Čínština Jin',
    'hsn': 'Čínština Xiang',
    'gan': 'Čínština Gan',
    'mnp': 'Severná Mincština',

    // Arabic dialects (sort_order 81-95)
    'arz': 'Egyptská arabčina',
    'apc': 'Levantská arabčina',
    'acm': 'Mezopotámska arabčina',
    'acq': 'Taʽizzi-adenská arabčina',
    'ayl': 'Sanaanská hovorová arabčina',
    'acw': 'Hejázska arabčina',
    'aeb': 'Tuniská arabčina',
    'arq': 'Alžírska arabčina',
    'ary': 'Marocká arabčina',
    'apd': 'Sudánska arabčina',
    'aec': 'Saʽidská arabčina',

    // Other languages (sort_order 96+)
    'jv': 'Jávčina',
    'ceb': 'Cebuánčina',
    'su': 'Sundčina',
    'fa': 'Perzština (iránska)',
    'ps': 'Paštčina (severná)',
    'pbt': 'Paštčina (južná)',
    'ku': 'Kurdčina (severná)',
    'uz': 'Uzbečtina (severná)',
    'kk': 'Kazaština',
    'ug': 'Ujgurčina',
    'azb': 'Južná azerbajdžančina',
    'ha': 'Hauština',
    'yo': 'Jorubčina',
    'ig': 'Igboština',
    'fuv': 'Nigerská fulbčina',
    'am': 'Amharčina',
    'so': 'Somálčina',
    'rw': 'Rwandčina',
    'rn': 'Rundčina',
    'zu': 'Zulčina',
    'ctg': 'Čittagongčina',
    'syl': 'Sylhetčina',
    'dcc': 'Dakkánčina',
    'rom': 'Rómčina'
  }
};
